import React from 'react';
import classNames from 'classnames';
import { range } from 'lodash-es';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { Pagination as TPagination } from 'src/types';

type Props = {
  className?: string;
  paginationData: TPagination;
  window: number;
  onClick: (page: number) => void;
  buildPaginationUrl?: (page: number) => string | undefined;
  pager?: 'span' | 'a';
};

const Pagination: React.FC<Props> = ({ className = '', paginationData, window, onClick, buildPaginationUrl, pager = 'span'  }) => {
  const Pager = pager
  const canDisplayPage = (page: number) => {
    return (
      page <= paginationData.currentPage + window && page >= paginationData.currentPage - window
    );
  };
  const canDislayGap = (page: number) => {
    return (
      page === paginationData.currentPage - window - 1 ||
      page === paginationData.currentPage + window + 1
    );
  };

  const handleOnclick = (page: number) => {
    if (buildPaginationUrl || paginationData.currentPage === page) {
      null
    } else {
      onClick(page)
    }
  }

  return paginationData.totalPages > 1 ? (
    <nav className={`pagination ${className}`}>
      {paginationData.prevPage && (
        <Pager
          href={buildPaginationUrl?.(paginationData.prevPage)}
          className="pagination__item tw-cursor-pointer prev"
          onClick={() => paginationData.prevPage && handleOnclick(paginationData.prevPage)}
        >
          <FiChevronLeft width={24} height={24} />
        </Pager>
      )}
      {range(paginationData.totalPages).map((index) => {
        let page = index + 1;
        return canDisplayPage(page) ? (
          <Pager
            key={page}
            href={buildPaginationUrl?.(page)}
            className={classNames('pagination__item', {
              'current': paginationData.currentPage === page,
              'tw-cursor-pointer tw-text-brand-navy': paginationData.currentPage !== page,
            })}
            onClick={()=> handleOnclick(page)}
          >
            {page}
          </Pager>
        ) : canDislayGap(page) ? (
          <span key={`gap-${index}`} className="pagination__item gap">
            ...
          </span>
        ) : (
          ''
        );
      })}
      {paginationData.nextPage && (
        <Pager
          href={buildPaginationUrl?.(paginationData.nextPage)}
          className="pagination__item tw-cursor-pointer next"
          onClick={()=> paginationData.nextPage && handleOnclick(paginationData.nextPage)}
        >
          <FiChevronRight width={24} height={24} />
        </Pager>
      )}
    </nav>
  ) : null;
};

export default Pagination;
